import saveMfgLookup from 'api/saveMfgLookup';
import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { reset } from 'redux/modules/mfgLookup/slice';

const useSave = (): [(form: any) => Promise<void>, boolean] => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const save = useCallback(
    async (form) => {
      setLoading(true);

      try {
        await saveMfgLookup(form);

        dispatch(reset());
      } catch {
        setLoading(false);
      }
    },
    [dispatch]
  );

  return [save, loading];
};

export default useSave;
